import * as React from 'react'
import { ChevronLeft, ChevronRight, MoreHorizontal } from 'lucide-react'


const Pagination = ({ className, ...props }) => (
    <nav
        role="navigation"
        aria-label="pagination"
        className={('mx-auto flex w-full justify-center', className)}
        {...props}
    />
)

const PaginationContent = React.forwardRef(({ className, ...props }, ref) => (
    <ul
        ref={ref}
        className={('flex flex-row items-center gap-1', className)}
        {...props}
    />
))
PaginationContent.displayName = 'PaginationContent'

const PaginationItem = React.forwardRef(({ className, ...props }, ref) => (
    <li ref={ref} className={('', className)} {...props} />
))
PaginationItem.displayName = 'PaginationItem'

const PaginationLink = ({
    className,
    isActive,
    size = 'icon',
    children,
    ...props
}) => (
    <PaginationItem>
        <a
            aria-current={isActive ? 'page' : undefined}
            className={(
                // buttonVariants({
                //     variant: isActive ? 'outline' : 'ghost',
                //     size,
                // }),
                className
            )}
            {...props}
        >
            {children}
        </a>
    </PaginationItem>
)
PaginationLink.displayName = 'PaginationLink'

const PaginationPrevious = ({
    className,
    ...props
}) => (
    <PaginationLink
        aria-label="Go to previous page"
        size="default"
        className={('gap-1 pl-2.5', className)}
        {...props}
    >
        <ChevronLeft className="h-4 w-4" />
        <span>Previous</span>
    </PaginationLink>
)
PaginationPrevious.displayName = 'PaginationPrevious'

const PaginationNext = ({ className, ...props }) => (
  <PaginationLink
    aria-label="Go to next page"
    size="default"
    className={('gap-1 pr-2.5 select-none', className)}
    {...props}
  >
    <span>Next</span>
    <ChevronRight className="h-4 w-4" />
  </PaginationLink>
);

const PaginationEllipsis = ({
    className,
    ...props
}) => (
    <span
        aria-hidden
        className={('flex h-9 w-9 items-center justify-center', className)}
        {...props}
    >
        <MoreHorizontal className="h-4 w-4" />
        <span className="sr-only">More pages</span>
    </span>
)

export {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
}
